<template>
  <DeliveredReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Moment from "moment";
import {AllowDeliveredStatistics} from "@/enums/permission";
import DeliveredReport from "@/components/report/DeliveryStatistics/DeliveredReportComponent.vue";

export default {
  name: "DeliveredReportView",
  components: {
    DeliveredReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeliveredStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, region, area, isAllClientsSelected, selectedFilters, type} = filters;

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getDeliveredReport({
        regionId: region.id,
        areaId: area?.id,
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        isAllClientsSelected: isAllClientsSelected,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        type: type
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                PostIndexName: rvm.PostIndexName,
                PrintedForPeriodResult: rvm.PrintedForPeriodResult,
                DeliveredBeforeTime: rvm.DeliveredBeforeTime,
                DeliveredAfterTime: rvm.DeliveredAfterTime,
                DeliveredCount: rvm.DeliveredCount,
                ReturnedBeforeTime: rvm.ReturnedBeforeTime,
                ReturnedAfterTime: rvm.ReturnedAfterTime,
                ReturnedCount: rvm.ReturnedCount,
                BeforeTimeEnteredInformation: rvm.BeforeTimeEnteredInformation,
                AfterTimeEnteredInformation: rvm.AfterTimeEnteredInformation,
                EnteredInformationCount: rvm.EnteredInformationCount
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика о доставке")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
